<template>
	<div class="">
		<div class="wrap_body">
				<div class="content_box">
					<div class="right_con">
						<div class="rc_main" v-loading="isLoading">
							<div class="select_wrap">
								<el-input class="w290 mr" @clear="autoFocus()" v-model="searchData.aftersales_express_no" @input="getList" placeholder="请输入快递单号" clearable ref="autoInput">
									<p slot="prefix" class="label_title">快递单号</p>
								</el-input>
								<!-- <el-date-picker class="mr w290"
									v-model="searchData.search_date"
									type="datetimerange"
									align="right"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyy-MM-dd HH:mm:ss"
									:picker-options="pickerOptions"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker> -->
								<el-button plain size="small" @click="getList">查询</el-button>
								<el-button plain size="small" @click="resetSearch">重置</el-button>
								
							</div>
							
							
							<el-table class="rc_table" highlight-current-row  :data="list" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
								<el-table-column align="left"  property="scope" label="买家/收货人" width="200px">
									<template slot-scope="scope" >
										<p>{{scope.row.order_address.mask_name}}</p>
										<p>{{scope.row.order_address.mask_phone}}</p>
										<p>{{scope.row.order_address.province}}{{scope.row.order_address.city}}{{scope.row.order_address.town}}{{scope.row.order_address.mask_detail}}</p>
									</template>
								</el-table-column>
								<el-table-column align="left"  property="freight_price" label="运费" width="80px"></el-table-column>
								<el-table-column align="left"  property="scope" label="订单信息 / 售后操作" show-overflow-tooltip width="">
									<template slot-scope="scope">
										<div class="order_info">
											<div class="order_product">
												<div class="product_item"  v-for="(product,pindex) in scope.row.supplier_order_product">
													<div class="goods_info">
														<div class="img_wrap">
															<div class="img_box">
																<img class="coverimg" :src="product.product_pic" />
															</div>
															<!-- <el-link v-if="product.is_cancel==0" style="margin-top: 10px;" icon="el-icon-s-release" type="danger" @click="setOutOfStock(product.id)">缺货</el-link> -->
														</div>
													
														<div class="con_box">
															<p class="title">{{product.product_name}}</p>
															<p class="t1">{{product.spec_value}}</p>
															<p class="t2">商家：{{scope.row.order.business.nickname}}</p>
														<!-- 	<p class="t2"><span class="remark">备注：<span :title="product.supplier_remark">{{product.supplier_remark}}</span> <i class="iconfont el-icon-edit" @click="showRemark(product)"></i></span></p> -->
														</div>
													</div>
													<div class="goods_num">
														<p class="t1">{{product.item_amount}}</p>
														<p class="t2">x{{product.item_num}}</p>
													</div>
													<div class="goods_sales">
														<!-- <p class="black">{{product.order_status_text}}</p> -->
														<p class="black" v-if="product.is_cancel==1">取消采购</p>
														<p class="black" v-if="product.is_cancel==0">已采购</p>
														<!-- <p class="warning" v-if="product.order_after_sales">{{product.order_after_sales.aftersale_status_text}}</p> -->
														<p class="warning" v-if="product.is_out_of_stock">缺货</p>
														<div v-if="product.order_after_sales">
															<p class="red" @click="showAfterSaleInfo(product)">{{product.order_after_sales.aftersale_status_text}}</p>
															<p class="red" @click="showAfterSaleInfo(product)" v-if="product.order_after_sales.aftersale_status==6||product.order_after_sales.aftersale_status==11">系统将在{{product.order_after_sales.status_deadline}}后自动同意</p>
														</div>
														
													</div>
												</div>
											</div>
											<!-- <div class="goods_pay">
												<p class="t1">￥{{scope.row.freight_price}}</p>
											</div> -->
										</div>
									</template>
								</el-table-column>
								
							</el-table>
							<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" v-if="page_data.total>page_data.limit" />
						</div>
					</div>
				</div>
				<!-- 售后详情弹窗 -->
				<el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" center :append-to-body="true" @close="autoFocus()">
					<orderAfterSales @close="dialog.aftersaleDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.aftersaleDialog" :info.sync="supplier_order_product" @complete="getList()"></orderAfterSales>
				</el-dialog>
		</div>
		
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import orderAfterSales from '../../components/orderAfterSales/orderAfterSales';
import { Loading } from 'element-ui';
import Pagination from '../../components/pagination/pagination';
import common from '../../assets/js/utils/common.js';
export default {
	name: "orderTags",
	components:{
		Pagination,orderAfterSales
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			isLoading: false,
		
			page_data: {
				limit: 10,
				page: 1,
				total:0,
			},
			searchData:{
				order_no:'',
				order_status: 8,
				aftersales_express_no: ''
			},
			form:{},
			dialog: {
				aftersaleDialog:false,
			},
			supplier_order_product: null,
			list:[],
			ids:[],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	created() {
	},
	watch: {
		show(val) {
			if (val) {
				let that = this
				setTimeout(function(){
					that.$refs.autoInput.focus();
				},100)
				
			}
		}
	},
	methods: {
		...mapActions({
			getSupplierOrderList:"ucenter/getSupplierOrderList",
		}),
		
		autoFocus(){
			this.$refs.autoInput.focus();
		},
		getList(showLoading = true){
			if(!this.searchData.aftersales_express_no){
				this.list = []
				this.$message({message: '请输入快递单号',type: 'info',});
				return
			}
			if(showLoading) this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page}
			Object.assign(param, this.searchData)
			// console.log(param)
			this.getSupplierOrderList({data:param,success:(res)=>{
				if(res.code===200){
					// console.log('get order list',res)
					this.list = res.data.data
					this.page_data.total = res.data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.isLoading = false
			}})
		},
		
		resetSearch(){//重置搜索
			this.searchData = {
				order_status: 8,
				aftersales_express_no: ''
			}
			this.list = []
			this.$refs.autoInput.focus();
		},
		closeMask(){//关闭弹窗
			this.form = {}
		},
		showAfterSaleInfo(supplier_order_product){
			this.supplier_order_product = supplier_order_product
			this.dialog.aftersaleDialog = true
		},
		
	}
}

</script>

<style scoped>
.wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.content_box{padding: 0px 0 40px;display: flex;justify-content: space-between;flex: 1;min-height: 300px;}
.right_con{width: 100%;background: #fff;}
.rc_table{width: 100%;margin-top: 20px}
.rc_main{padding: 0px 40px 46px;}
.select_wrap{display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 15px;}
.select_wrap .w290{width: 290px;margin-top: 14px;margin-right: 15px;position: relative;}
.select_wrap .w290:nth-child(3n){margin-right: 0;}
.el-cascader{line-height: 34px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.tree_checkall{margin-top: 12px;}
.tree_box{padding: 10px;width: 100%;border: 1px solid #DCDFE6;border-radius: 4px;box-sizing: border-box;max-height: 250px;overflow: hidden auto;margin-top: 12px;}
.tree_box::-webkit-scrollbar{width:4px;}
.tree_box::-webkit-scrollbar-thumb{background: #DDDDDD;border-radius: 4px;}
.tree_box::-webkit-scrollbar-track{background: #F2F2F2;border-radius: 4px;}
.w100{width: 100%;}

.order_info{padding: 20px 0;display: flex;align-items: flex-start;line-height: 1;}
.order_info .order_product{display: felx;flex-direction: column;}
.order_info .order_product .product_item{display: flex;padding-bottom: 20px;}
.order_info .order_product .product_item:last-child{padding-bottom: 0;}
.order_info .goods_info{width: 360px;display: flex;margin-left: 20px;}
.order_info .goods_info .img_box{width: 48px;height: 48px;background-color: #eeeeee;border-radius: 6px;overflow: hidden;}
.order_info .goods_info .con_box{flex: 1;width: 0;margin-left: 10px;text-align: left;}
.order_info .goods_info .con_box .title{white-space: normal;line-height: 16px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.order_info .goods_info .con_box .t1{color: #999999;margin-top: 12px;}
.order_info .goods_info .con_box .t2{color: #999999;margin-top: 8px;}
.order_info .goods_info .con_box .t2 .remark{display: inline-flex;align-items: center;width: 100%;position: relative;white-space: nowrap;color: #f0b92c;}
.order_info .goods_info .con_box .t2 .remark span{white-space: nowrap;text-overflow: ellipsis;overflow: hidden;display: inline-block;max-width: 80%;}
.order_info .goods_info .con_box .t2 .remark i{margin-left: 5px;cursor: pointer;}
.order_info .goods_info .con_box .guanlian{color: #1966ff;margin-top: 8px;cursor: pointer;}
.order_info .goods_info .con_box .guanlian:hover{text-decoration: underline;}
.order_info .goods_num{margin: 0 20px;width: 60px;text-align: right;}
.order_info .goods_num .t1{color: #333333;}
.order_info .goods_num .t2{color: #999999;margin-top: 10px;}
.order_info .goods_sales{margin: 0 10px;width: 120px;text-align: left;}
.order_info .goods_sales p{color: #333;margin-bottom: 5px;}
.order_info .goods_sales p.red{color: var(--red);cursor: pointer;}
.order_info .goods_sales p.warning{color: #f0b92c;}
.order_info .goods_pay{margin-left: 20px;width: 60px;text-align: right;}
.order_info .goods_pay .t1{color: #333333;}
.order_info .goods_pay .t2{color: #333333;margin-top: 10px;}
.order_info .goods_pay .t3{color: #666666;margin-top: 20px;}
.order_info .goods_pay .t4{color: #666666;margin-top: 10px;}
.order_info .goods_buyer{margin: 0 20px;width: 150px;text-align: left;}
.order_info .goods_buyer>p{line-height: 18px;color: #666;}
.order_info .goods_buyer>p .iconfont{cursor: pointer;font-size: 12px;color: #666;margin-left: 8px;}
.order_info .goods_status{margin: 0 20px 0 0;flex: 1;text-align: left;}
.order_info .goods_status:last-child{text-align: right;}
.order_info .goods_status>p{margin-bottom: 10px;}
.order_info .goods_status .details{color: #f0413e;cursor: pointer;}
.order_info .goods_status .details:hover{text-decoration: underline;}
.order_info .goods_status p>a{color: #f0413e;cursor: pointer;}
.order_info .goods_status p>a:hover{text-decoration: underline;}
</style>
<style>
.el-cascader{width: 100%;}
.select_wrap .el-button{margin-top: 14px;}
.select_wrap .el-input--prefix .el-input__inner,.select_wrap .el-cascader .el-input .el-input__inner{padding-left: 76px !important;height: 34px;line-height: 34px;font-size: 12px !important;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.select_wrap .el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}
.totals_btn .el-button--primary.is-plain{border-color: #fff;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-input.is-focus .el-input__inner,.el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}
.rc_table.el-table th.el-table__cell>.cell{padding: 0 14px;}
</style>